<template>
  <div class="certificate-info">
    <div v-if="overData.answerCertificate.effType === 1" @click="onPreview">
      <Certificate ref="certificate" :overData="overData" :surveyId="survey.id" :survey="survey"/>
      <van-button type="primary" block class="text-medium-x">长按图片保存证书</van-button>
    </div>
    <div v-if="overData.answerCertificate.effType === 2">
      <div v-html="overData.answerCertificate.scoreOutsideTips.richText"></div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
const Certificate = () => import('components/certificate/Certificate')

export default {
  name: 'CertificateInfo',
  components: { Certificate },
  props: {
    overData: {
      type: Object,
      default: {}
    },
    survey: {
      type: Object,
      default: {}
    },
  },
  methods: {
    onPreview() {
      ImagePreview({
        images: [this.$refs.certificate.imgSrc],
        closeable: true
      })
    },
  },
  created() {
    if(this.overData.answerCertificate.effType === 2) {
      this.overData.answerCertificate.scoreOutsideTips.richText = (this.overData.answerCertificate.scoreOutsideTips.richText || '').replaceAll('[Score]', this.overData.score)
    }
  }
}
</script>

<style scoped lang="scss"></style>
